import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { trackElementInteraction } from '@/common/analytics/gtm/shared/trackElementInteraction';
import { LISTING_FUNCTIONS } from '@/common/analytics/gtm/types';
import { generateItemListId } from '@/common/analytics/utils';
import { FollowButtonMetadata } from '@/common/components/FollowButton/FollowButton';
import { AthenaEvent } from '@/common/hooks/useAthena/athenaEvents';

export interface TrackFollowProps
  extends Omit<FollowButtonMetadata, 'listingFunction' | 'pageType'> {
  authorId: number;
}

export const trackFollow = ({ componentLocation, authorId, authorName }: TrackFollowProps) =>
  createTrackingEvent({
    event: 'follow',
    follow_location: componentLocation,
    follow_id: authorId.toString(),
    follow_name: authorName,
  });

export const trackFollowButtonClick = (elementVariant: string) =>
  trackElementInteraction({
    elementId: 'follow_button',
    elementVariant,
  });

export const trackUnfollow = ({ componentLocation, authorId, authorName }: TrackFollowProps) =>
  createTrackingEvent({
    event: 'unfollow',
    follow_location: componentLocation,
    follow_id: authorId.toString(),
    follow_name: authorName,
  });

export const trackAthenaFollowClick = (
  eventName: 'follow' | 'followIntention' | 'unfollow',
  pushEvent: (event: AthenaEvent) => void,
  trackingData: {
    metadata: FollowButtonMetadata;
    authorId: number;
    userId?: number;
  },
) => {
  const { metadata, authorId, userId } = trackingData;
  const { componentLocation, pageType, listingFunction, authorName } = metadata;

  pushEvent({
    eventType: 'click',
    eventName,
    context: {
      authorId,
      authorName: authorName,
      userId,
      context: {
        itemListId: generateItemListId(pageType, componentLocation, listingFunction),
      },
    },
  });
};

export const trackAthenaFollowingView = (
  pushEvent: (event: AthenaEvent) => void,
  pageType: string,
  userId?: number,
) => {
  pushEvent({
    eventType: 'view',
    eventName: 'followList',
    context: {
      userId,
      context: {
        itemListId: generateItemListId(pageType, 'masonry', LISTING_FUNCTIONS.FOLLOW),
      },
    },
  });
};
